import CXMApiClient from "../CXMApiClient";
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";
function initialState() {
    return {

    };
  }
  
  const state = initialState();
  
  const getters = {};
  
  const actions = {
    getRawAdfXml: function(context, crmRawLeadId) {
      const scope = HelperFunctions.getCurrentCustomerScope();
        return new Promise((resolve, reject) => {
          let cxmApiClient = new CXMApiClient();
          cxmApiClient
            .ProcessRequest("GET", `/api/CrmRawLead/${crmRawLeadId}/raw_adf_xml`, null, scope)
            .then(resp => {
              if (resp && resp.data) resolve(resp.data);
              else reject(data);
            })
            .catch(resp => {
              reject(resp);
            });
        });
      },
  };


  const mutations = {};

  export default { state, getters, actions, mutations };


// WEBPACK FOOTER //
// ./src/store/modules/CrmRawLead.js